import {
  WSButton,
  WSCheckboxToggle,
  WSText
} from "@wingspanhq/fe-component-library";
import { payeesApi } from "@api";
import { useWSMutation } from "@ws-react-query";
import React, { useState } from "react";
import { AutopaySetupParams } from ".";
import { QUERY_PAYEE } from "../../../../query/payee/keys";
import { useXWingspanPayerId } from "../../../../modules/Payees/routes/RoutePayeeDetails/useXWingspanPayerId";
import { SetupRouteComponentProps } from "../../../../shared/components/FlowSetup";
import { useSetWSStore } from "../../../../store";
import { SetupAutopayLayout } from "./SetupAutopayLayout";

export const SetupConsent: React.FC<
  SetupRouteComponentProps<AutopaySetupParams>
> = ({ onBack, onNext, params }) => {
  const [agreement, setAgreement] = useState(false);
  const setStore = useSetWSStore();
  const xWingspanAccount = useXWingspanPayerId();

  const [submit, submitMeta] = useWSMutation(
    async () => {
      if (!params?.payeeId) return;

      // v3: per-payee autopay lives on `PayeeUpdate.defaults.isAutoPayEnabled`
      // (enum `All` → boolean). `params.payeeId` is a v3 `Payee` id — the flow
      // already reads it via `queriesPayees.getPayee` (AutopaySetup).
      await payeesApi.updatePayee({
        payeeId: params.payeeId,
        payeeUpdate: { defaults: { isAutoPayEnabled: true } },
        xWingspanAccount
      });

      // clear setup autopay data;
      window.sessionStorage.removeItem("signUpAutopayDetails");
      setStore({ signUpAutopayDetails: undefined });
    },
    {
      onSuccess: onNext,
      dependencies: [[QUERY_PAYEE, params?.payeeId]]
    }
  );

  if (!params?.payeeId) {
    return null;
  }

  return (
    <SetupAutopayLayout
      payeeId={params.payeeId}
      onBack={onBack}
      title={payeeName => `Consent to paying ${payeeName} automatically?`}
    >
      {({ payeeName }) => (
        <>
          <WSText mb="XL">
            {`Easily automate your ${payeeName} invoice payments with our Autopay feature.`}
          </WSText>
          <WSText>
            By enrolling, you authorize us to securely charge your payment
            method for each invoice, ensuring timely and hassle-free
            transactions. Review the terms, provide your consent, and let
            Autopay manage the rest.
          </WSText>

          <WSCheckboxToggle
            my="XL"
            name="agreenment"
            label={`I agree to enroll in Autopay for ${payeeName}`}
            value={agreement}
            onChange={value => {
              setAgreement(value);
            }}
          />

          <WSButton
            disabled={!agreement}
            fullWidth
            onClick={submit}
            loading={submitMeta.isLoading}
          >
            Continue
          </WSButton>
        </>
      )}
    </SetupAutopayLayout>
  );
};
